<template>
  <div class="coupon">
    <span class="integral">{{$t('other.w82').replace('{%}',assets.IntegralCount)}}</span>
    <div class="couponBox">
      <div class="nav">
        <span :class="{active:statu==0}" @click="statu=0">{{$t('option.w56')}}</span>
        <span :class="{active:statu==2}" @click="statu=2">{{$t('option.w57')}}</span>
        <span :class="{active:statu==3}" @click="statu=3">{{$t('option.w58')}}</span>
      </div>
      <div class="cardbox">
        <Row class="cardmain">
          <Datatable url="/Member/RZJProfile/MyCoupons" field="MyCoupon" v-slot="{item}" viewtype="list" :filter="{statu}" :tip="tip">
            <Col span="8" class="cardcontent" :class="{cardbg:item.Status == 0 && statu != 3}" >
              <div class="num">
                <!-- 管理费减免券新增 -->
                <div class="discount" v-if="item.Type === 5">
                  <icons icon="icon-rzjmian" size="34" color="#001955" />
                </div>
                <!-- 管理费减免券新增 end -->
                <div class="discount" :class="{purple:item.Status==0}" v-else>
                  <span :class="[item.Rate == 0 ? sym : percent]">{{item.Rate == 0 ? '￥' : '%'}}</span>
                  {{item.Rate== 0 ? item.Amount : item.Rate}}
                </div>
                <div class="rule">
                  <!-- 管理费减免券新增 -->
                  <template v-if="item.Type == 5">
                    <p :class="{black: item.Status == 0 && statu != 3}">{{item.TypeName}}</p>
                    <p :class="{gray: item.Status == 0 && statu != 3}" v-show="item.Type==5">{{$t('other.w151')}}</p>
                  </template>
                  <!-- 管理费减免券新增 end -->
                  <template v-else>
                    <p :class="{black:item.Status == 0}">{{item.TypeName}}</p>
                    <p :class="{gray:item.Status==0}">{{$t('other.w83').replace('{%}',item.InvestAmount)}}</p>
                  </template>
                </div>
              </div>
              <div class="desc">
                <p>{{$t('label.w127')}}：{{item.ExpiredAt}}</p>
                <!-- 管理费减免券新增 -->
                <p v-if="item.Type==5">{{$t('other.w152')}}</p>
                <p v-else>{{item.Description}}</p>
              </div>
              <div class="timeout-img passed" v-if="item.Status==0 && statu == 3"></div>
              <div class="timeout-img used" v-if="item.Status==2 || item.Status==1"></div>
              <div class="timeout-img" v-if="item.Status==3"></div>
            </Col>
          </Datatable>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
// import { watch } from 'fs';
import Datatable from "@/components/datatable"
export default {
  components:{Datatable},
  data() {
    return {
      sym: "sym",
      percent: "percent",
      statu: 0,
    };
  },
  computed:{
    assets(){
      return this.$store.state.user.assets
    },
    tip(){
      if(this.statu== 0){
        return this.$t('msg.m112')
      }
      if(this.statu== 2){
        return this.$t('msg.m113')
      }
      if(this.statu== 3){
        return this.$t('msg.m114')
      }
    }
  }
};
</script>

<style scoped lang='less'>
.coupon {
  min-height: 700px;
  width: 100%;
  background: #f1f2f5;
  position: relative;
  .integral {
    font-size: 14px;
    font-weight: 500;
    color: rgba(106, 152, 255, 1);
    position: absolute;
    right: 0;
    top: -40px;
  }
  .couponBox {
    width: 1200px;
    padding-top: 20px;
    margin: 0 auto;
    .purple {
      color: #001955 !important;
    }
    .black {
      color: #232325 !important;
    }
    .gray {
      color: #7b7b7c !important;
    }
    .nav {
      display: flex;
      justify-content: center;
      span {
        width: 100px;
        height: 40px;
        border-radius: 8px;
        line-height: 40px;
        font-size: 14px;
        font-weight: 500px;
        color: rgba(123, 123, 124, 1);
        text-align: center;
        cursor: pointer;
        margin: 0 10px;
      }
      .active {
        color: #fff;
        background: rgba(94, 143, 252, 1);
      }
    }
  }
  .cardbox {
    width: 1200px;
    .cardmain {
      width: 1020px;
      height: 100%;
      padding-top: 35px;
      margin: 0 auto;
      .cardcontent {
        border-radius: 2px;
        height: 133px;
        width: 320px;
        margin: 0 10px 50px 10px;
        background: url(../../assets/assetcenter/card_disable.png) no-repeat;
        background-size: cover;
        position: relative;
        .num {
          width: 100%;
          height: 97px;
          display: flex;
          justify-content: space-between;
          .discount {
            font-size: 48px;
            margin-left: 30px;
            color: #d1d1d1;
            font-weight: bold;
            font-family: DIN-Bold;
            position: relative;
            .percent {
              font-size: 18px;
              font-family: DIN-Medium;
              font-weight: 500;
              position: absolute;
              right: -15px;
              top: 35px;
            }
            .sym {
              font-size: 18px;
              font-family: DIN-Medium;
              font-weight: 500;
              position: absolute;
              left: -15px;
              top: 10px;
            }
          }
          .rule {
            p {
              text-align: right;
              margin: 18px 20px 0 0;
              font-size: 18px;
              font-weight: 500;
              color: #d1d1d1;
            }
            p:last-child {
              font-size: 14px;
              margin-top: 0;
            }
          }
        }
        .desc {
          width: 100%;
          height: 36px;
          font-size: 14px;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: space-between;
          p:first-child {
            margin-left: 20px;
          }
          p:last-child {
            margin-right: 20px;
          }
        }
      }
      .cardbg {
        background: url(../../assets/assetcenter/card_normal.png) no-repeat;
        background-size: cover;
      }
      .timeout-img {
        position: absolute;
        bottom: 10px;
        right: 20px;
        width: 68px;
        height: 65px;
        background: url("../../assets/assetcenter/card_overdue.png") no-repeat;
        background-size: cover;
      }
      .passed {
        background: url("../../assets/assetcenter/card_overdue.png") no-repeat;
        background-size: cover;
      }
      .used {
        background: url("../../assets/assetcenter/card_used.png") no-repeat;
        background-size: cover;
      }
    }
  }
}
</style>
